/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ArticleDiscrepanciesRequest } from '../../models/article-discrepancies-request';
import { ArticleDiscrepanciesResponse } from '../../models/article-discrepancies-response';
import { KeyType } from '../../models/key-type';

export interface PutConsigneeArticleDiscrepancies$Params {
  organizationSiteKey: KeyType;
  deliveryNoteKey: KeyType;
  articleKey: KeyType;
      body: ArticleDiscrepanciesRequest
}

export function putConsigneeArticleDiscrepancies(http: HttpClient, rootUrl: string, params: PutConsigneeArticleDiscrepancies$Params, context?: HttpContext): Observable<StrictHttpResponse<ArticleDiscrepanciesResponse>> {
  const rb = new RequestBuilder(rootUrl, putConsigneeArticleDiscrepancies.PATH, 'put');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('deliveryNoteKey', params.deliveryNoteKey, {});
    rb.path('articleKey', params.articleKey, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ArticleDiscrepanciesResponse>;
    })
  );
}

putConsigneeArticleDiscrepancies.PATH = '/organization-sites/{organizationSiteKey}/consignee/delivery-notes/{deliveryNoteKey}/articles/{articleKey}/discrepancies';
